import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllFinancialRecurrences = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/financial-recurrences',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveFinancialRevenues = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/financial-revenues',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateFinancialRecurrences = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/financial-recurrences/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteFinancialRecurrences = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/financial-recurrences/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllFinancialRecurrences,
  saveFinancialRevenues,
  deleteFinancialRecurrences,
  updateFinancialRecurrences,
}
